import React, { useState } from 'react'
import { SelectorDialog } from '../../../../components'
import { SEARCH_CONFIG } from '../../../../config/saerchConfig'
import { ReactComponent as Logo } from '../../../../assets/logo_white.svg'
import styles from './styles.module.scss'

export const SearchModal = ({ isSearchOpen, toggleSearch }) => {
    const [text, setText] = useState('')

    return (
        <SelectorDialog
            open={isSearchOpen}
            onClose={toggleSearch}
            keepMounted={false}
            className={styles.modal}
            closeButtonVariant="iconOnly"
        >
            <a href="/">
                <Logo style={{ marginTop: 30 }} />
            </a>
            <form
                className={styles.form}
                onSubmit={(e) => {
                    e.preventDefault()

                    window.location.href = `${SEARCH_CONFIG.pathSegment}/?${
                        SEARCH_CONFIG.queryKey
                    }=${encodeURIComponent(text.trim())}`
                }}
            >
                <input
                    className={styles.input}
                    placeholder="Recherchez une info, un article, un document..."
                    type="text"
                    autoFocus
                    value={text}
                    onChange={(e) => {
                        setText(e.target.value)
                    }}
                />
                <span className={styles.inputBorder} />
            </form>
        </SelectorDialog>
    )
}
